import { SEOHead } from "../components/SEOHead";
import { STATIC_PAGES } from "../seo/pages";
import { PublicHeader } from "../components/PublicHeader";
import "../styles/PublicCommon.css";
import "./RecruitPage.css";

export const RecruitPage = () => {
  return (
    <>
      <SEOHead page={STATIC_PAGES.recruit} />

      <div className="public-page">
        <PublicHeader activePage="recruit" />

        {/* メインコンテンツ */}
        <main id="main-content" role="main">
          {/* ヒーローセクション */}
          <section className="recruit-hero" aria-labelledby="recruit-hero-heading">
            <div className="recruit-hero-overlay" />
            <div className="recruit-hero-content">
              <p className="recruit-hero-label">RECRUIT</p>
              <h1 id="recruit-hero-heading" className="recruit-hero-title">
                共に、街をつくる。
              </h1>
              <p className="recruit-hero-subtitle">
                あなたの手で、地域の未来を築きませんか
              </p>
              <a href="/contact?subject=採用に関して" className="recruit-hero-cta">
                エントリーする
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
            </div>
            <div className="recruit-hero-scroll">
              <span>Scroll</span>
              <div className="scroll-line" />
            </div>
          </section>

          {/* メッセージセクション */}
          <section className="recruit-message-section" aria-labelledby="message-heading">
            <div className="container">
              <div className="recruit-message-content">
                <div className="recruit-message-label">MESSAGE</div>
                <h2 id="message-heading" className="recruit-message-title">
                  未経験者も安心の職場です
                </h2>
                <p className="recruit-message-text">
                  政府が進める働き方改革を進めております。<br />
                  資格を取りたい方には資格支援制度、<br className="sp-only" />
                  未経験の方でも安心して働ける環境づくりを心がけております。
                </p>
              </div>
            </div>
          </section>

          {/* 数字で見る都建設 */}
          <section className="recruit-numbers-section" aria-labelledby="numbers-heading">
            <div className="container">
              <h2 id="numbers-heading" className="section-heading">
                <span className="section-heading-en">NUMBERS</span>
                <span className="section-heading-ja">数字で見る都建設</span>
              </h2>
              <div className="numbers-grid">
                <div className="number-card">
                  <div className="number-value">
                    <span className="number">50</span>
                    <span className="number-unit">%以上</span>
                  </div>
                  <p className="number-label">未経験スタート率</p>
                  <p className="number-description">現在働いているスタッフの半分以上が未経験から</p>
                </div>
                <div className="number-card">
                  <div className="number-value">
                    <span className="number">2</span>
                    <span className="number-unit">回/年</span>
                  </div>
                  <p className="number-label">賞与</p>
                  <p className="number-description">年2回の賞与で頑張りをしっかり評価</p>
                </div>
                <div className="number-card">
                  <div className="number-value">
                    <span className="number">0</span>
                    <span className="number-unit">円</span>
                  </div>
                  <p className="number-label">社員寮家賃</p>
                  <p className="number-description">1人用社員寮を無料で提供</p>
                </div>
                <div className="number-card">
                  <div className="number-value">
                    <span className="number">週休</span>
                    <span className="number-unit">2日</span>
                  </div>
                  <p className="number-label">休日</p>
                  <p className="number-description">日曜日を含む週休2日制</p>
                </div>
              </div>
            </div>
          </section>

          {/* 職場環境ギャラリーセクション */}
          <section
            className="recruit-workplace-section"
            aria-labelledby="workplace-heading"
            style={{ padding: "100px 24px", background: "white" }}
          >
            <div className="container">
              <h2 id="workplace-heading" className="section-heading">
                <span className="section-heading-en">WORKPLACE</span>
                <span className="section-heading-ja">職場の雰囲気</span>
              </h2>
              <p
                style={{
                  textAlign: "center",
                  fontSize: 17,
                  lineHeight: 2,
                  color: "var(--text-light)",
                  margin: "-20px auto 48px",
                  maxWidth: 720,
                }}
              >
                朝礼から始まる1日、整備された作業場や倉庫、<br />
                社内ゴルフ練習場での息抜きまで、<br className="sp-only" />
                チームで支え合う風通しの良い職場です。
              </p>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
                  gap: 20,
                  maxWidth: 1100,
                  margin: "0 auto",
                }}
              >
                {[
                  {
                    src: "/static/%E7%A4%BE%E5%86%85%E9%96%A2%E4%BF%82/%E6%9C%9D%E7%A4%BC%E5%A0%B4%E6%89%80%EF%BC%92.JPG",
                    caption: "毎朝の朝礼でチームの一体感を",
                  },
                  {
                    src: "/static/%E7%A4%BE%E5%86%85%E9%96%A2%E4%BF%82/%E4%BD%9C%E6%A5%AD%E5%A0%B4.JPG",
                    caption: "整備された作業場",
                  },
                  {
                    src: "/static/%E7%A4%BE%E5%86%85%E9%96%A2%E4%BF%82/%E5%80%89%E5%BA%AB%E5%86%85.JPG",
                    caption: "資材を管理する倉庫",
                  },
                  {
                    src: "/static/%E7%A4%BE%E5%86%85%E9%96%A2%E4%BF%82/%E6%89%93%E3%81%A1%E5%90%88%E3%82%8F%E3%81%9B%E5%A0%B4%E6%89%80.JPG",
                    caption: "気軽に相談できる打ち合わせスペース",
                  },
                  {
                    src: "/static/%E7%A4%BE%E5%86%85%E9%96%A2%E4%BF%82/%E7%A4%BE%E5%86%85%E3%82%B4%E3%83%AB%E3%83%95%E7%B7%B4%E7%BF%92%E5%A0%B4.JPG",
                    caption: "社内ゴルフ練習場で息抜きも",
                  },
                  {
                    src: "/static/%E7%A4%BE%E5%86%85%E9%96%A2%E4%BF%82/1%E6%9C%885%E6%97%A5%E4%BB%95%E4%BA%8B%E5%88%9D%E3%82%81.JPG",
                    caption: "仕事始めなど、季節の行事も大切に",
                  },
                ].map((item) => (
                  <figure
                    key={item.src}
                    style={{
                      margin: 0,
                      borderRadius: 16,
                      overflow: "hidden",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                      background: "var(--bg-light)",
                    }}
                  >
                    <img
                      src={item.src}
                      alt={item.caption}
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: 220,
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                    <figcaption
                      style={{
                        padding: "14px 18px",
                        fontSize: 14,
                        color: "var(--text-color)",
                        background: "white",
                      }}
                    >
                      {item.caption}
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </section>

          {/* 福利厚生セクション */}
          <section className="recruit-benefits-section" aria-labelledby="benefits-heading">
            <div className="container">
              <h2 id="benefits-heading" className="section-heading">
                <span className="section-heading-en">BENEFITS</span>
                <span className="section-heading-ja">充実した福利厚生</span>
              </h2>
              <p className="benefits-intro">
                社員の法定外福利厚生に力をいれております。<br />
                働きやすい環境を整え、長く安心して働ける職場を目指しています。
              </p>
              <div className="benefits-grid">
                <div className="benefit-card">
                  <div className="benefit-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                      <polyline points="9 22 9 12 15 12 15 22" />
                    </svg>
                  </div>
                  <h3 className="benefit-title">社員寮無料</h3>
                  <p className="benefit-description">1人用社員寮を無料で提供</p>
                </div>
                <div className="benefit-card">
                  <div className="benefit-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                      <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                      <line x1="1" y1="10" x2="23" y2="10" />
                    </svg>
                  </div>
                  <h3 className="benefit-title">資格支援制度</h3>
                  <p className="benefit-description">資格取得を会社がサポート</p>
                </div>
                <div className="benefit-card">
                  <div className="benefit-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    </svg>
                  </div>
                  <h3 className="benefit-title">各種保険完備</h3>
                  <p className="benefit-description">社会保険・建築共済・退職金共済</p>
                </div>
                <div className="benefit-card">
                  <div className="benefit-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                  </div>
                  <h3 className="benefit-title">通勤車両支給</h3>
                  <p className="benefit-description">役職に応じて車両・燃料費を支給</p>
                </div>
                <div className="benefit-card">
                  <div className="benefit-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                      <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
                      <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
                      <line x1="6" y1="1" x2="6" y2="4" />
                      <line x1="10" y1="1" x2="10" y2="4" />
                      <line x1="14" y1="1" x2="14" y2="4" />
                    </svg>
                  </div>
                  <h3 className="benefit-title">昼食支給</h3>
                  <p className="benefit-description">役職に応じて昼食を支給</p>
                </div>
                <div className="benefit-card">
                  <div className="benefit-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                  </div>
                  <h3 className="benefit-title">各種割引制度</h3>
                  <p className="benefit-description">旅行・引越し・電気・自動車購入など</p>
                </div>
              </div>
              <div className="benefits-note">
                <p>
                  その他、お祝い金、医療・介護福祉、個人賠償責任保険、交通事故傷害保険、
                  くらしの相談制度、葬儀・お見舞金制度等、福利厚生の充実に力をいれております。
                </p>
              </div>
            </div>
          </section>

          {/* 社員の声セクション */}
          <section className="recruit-voices-section" aria-labelledby="voices-heading">
            <div className="container">
              <h2 id="voices-heading" className="section-heading">
                <span className="section-heading-en">VOICE</span>
                <span className="section-heading-ja">社員の声</span>
              </h2>
              <div className="voices-grid">
                <article className="voice-card">
                  <div className="voice-header">
                    <div className="voice-avatar">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                    </div>
                    <div className="voice-info">
                      <h3 className="voice-position">事務員</h3>
                    </div>
                  </div>
                  <blockquote className="voice-quote">
                    <p>
                      自然災害のリスクが高まる中、生活の安全と安心を重視し、お客様の希望に沿った事業を心がけております。
                    </p>
                  </blockquote>
                </article>
                <article className="voice-card">
                  <div className="voice-header">
                    <div className="voice-avatar">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1="16" y1="13" x2="8" y2="13" />
                        <line x1="16" y1="17" x2="8" y2="17" />
                      </svg>
                    </div>
                    <div className="voice-info">
                      <h3 className="voice-position">工事担当</h3>
                    </div>
                  </div>
                  <blockquote className="voice-quote">
                    <p>
                      安全第一、確かな技術をもって美しく快適な街作りに努めています。
                    </p>
                  </blockquote>
                </article>
              </div>
            </div>
          </section>

          {/* 募集要項セクション */}
          <section className="recruit-requirements-section" aria-labelledby="requirements-heading">
            <div className="container">
              <h2 id="requirements-heading" className="section-heading section-heading-white">
                <span className="section-heading-en">REQUIREMENTS</span>
                <span className="section-heading-ja">募集要項</span>
              </h2>
              <div className="requirements-table">
                <div className="requirement-row">
                  <div className="requirement-label">仕事内容</div>
                  <div className="requirement-value">
                    土木一式・解体工事等
                    <span className="requirement-note">※現在働いているスタッフは半分以上が未経験スタートです</span>
                  </div>
                </div>
                <div className="requirement-row">
                  <div className="requirement-label">勤務地</div>
                  <div className="requirement-value">
                    <div className="location-item">
                      <span className="location-type">本社</span>
                      〒797-0015 愛媛県西予市宇和町卯之町1丁目432番地
                    </div>
                    <div className="location-item">
                      <span className="location-type">作業所</span>
                      〒797-0020 愛媛県西予市宇和町久枝933-1
                    </div>
                  </div>
                </div>
                <div className="requirement-row">
                  <div className="requirement-label">応募資格</div>
                  <div className="requirement-value">
                    <ul className="requirement-list">
                      <li>要普通自動車免許（AT限定不可）</li>
                      <li>学歴不問・未経験者歓迎</li>
                      <li>施工管理の資格有りの場合、優遇</li>
                      <li>経験者優遇</li>
                    </ul>
                  </div>
                </div>
                <div className="requirement-row">
                  <div className="requirement-label">勤務時間</div>
                  <div className="requirement-value">8:00～17:00（休憩1時間）</div>
                </div>
                <div className="requirement-row">
                  <div className="requirement-label">給与</div>
                  <div className="requirement-value">当社規定による（経験・能力を考慮の上決定）</div>
                </div>
                <div className="requirement-row">
                  <div className="requirement-label">昇給・賞与</div>
                  <div className="requirement-value">昇給：有り / 賞与：年2回</div>
                </div>
                <div className="requirement-row">
                  <div className="requirement-label">休日休暇</div>
                  <div className="requirement-value">日曜日を含む週休2日</div>
                </div>
                <div className="requirement-row">
                  <div className="requirement-label">加入保険</div>
                  <div className="requirement-value">社会保険完備 / 建築共済 / 退職金共済</div>
                </div>
              </div>
            </div>
          </section>

          {/* CTAセクション */}
          <section className="recruit-cta-section" aria-labelledby="cta-heading">
            <div className="container">
              <div className="recruit-cta-content">
                <h2 id="cta-heading" className="recruit-cta-title">
                  一緒に働きませんか？
                </h2>
                <p className="recruit-cta-text">
                  まずはお気軽にお問い合わせください。<br />
                  会社見学も随時受け付けております。
                </p>
                <div className="recruit-cta-buttons">
                  <a href="/contact?subject=採用に関して" className="recruit-cta-button primary">
                    エントリーする
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </a>
                  <a href="tel:0894-62-4511" className="recruit-cta-button secondary">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    電話で問い合わせ
                  </a>
                </div>
                <p className="recruit-cta-note">受付時間：平日 9:00～17:00</p>
              </div>
            </div>
          </section>
        </main>

        {/* フッター */}
        <footer className="public-footer" role="contentinfo">
          <div className="footer-content">
            <div className="footer-logo">
              <img
                src="/static/miyako-logo-small.png"
                srcSet="/static/miyako-logo-small.png 1x, /static/miyako-logo-2x.png 2x"
                alt="都建設株式会社"
                className="footer-logo-image"
                width={60}
                height={45}
              />
              <span className="footer-company-name">都建設株式会社</span>
            </div>

            <address className="footer-address-block">
              <a
                href="https://maps.google.com/?q=愛媛県西予市宇和町卯之町1丁目432"
                className="footer-address"
                target="_blank"
                rel="noopener noreferrer"
              >
                〒797-0015 愛媛県西予市宇和町卯之町1丁目432
              </a>

              <a href="tel:0894-62-4511" className="footer-phone">
                お電話：<span itemProp="telephone">0894-62-4511</span>
              </a>
            </address>

            <nav className="footer-nav" aria-label="フッターナビゲーション">
              <a href="/">ホーム</a>
              <a href="/about">会社概要</a>
              <a href="/services">業務内容</a>
              <a href="/works">施工実績</a>
              <a href="/recruit">採用情報</a>
              <a href="/contact">お問い合わせ</a>
            </nav>

            <p className="footer-copyright">
              <small>
                ©2024 都建設株式会社 Powered by{" "}
                <a href="#" target="_blank" rel="noopener noreferrer">
                  VERYWEBB
                </a>
              </small>
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default RecruitPage;
